import { DownloadButton } from './DownloadButton';

export function Pricing() {
  return (
    <section className="bg-neutral-50 py-12 md:py-16">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-20">
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl md:rounded-3xl p-8 md:p-12">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            {/* Left: Pricing Info */}
            <div className="space-y-2">
              <p className="text-gray-400 text-sm uppercase tracking-wider">
                7-day free trial
              </p>
              <div className="flex items-baseline gap-2">
                <span className="text-white text-4xl md:text-5xl font-light">$1.99</span>
                <span className="text-gray-400 text-lg">/month</span>
              </div>
              <p className="text-gray-500 text-sm">
                No credit card required. Cancel anytime.
              </p>
              <p className="text-gray-400 text-sm">
                Less than a coffee, so you can enjoy yours with a clean desktop.
              </p>
            </div>

            {/* Right: CTA */}
            <div className="flex flex-col gap-3">
              <DownloadButton
                className="bg-[#FF6B6B] hover:bg-[#ff5252] text-white rounded-full px-10 h-12 text-base font-medium"
                showVersion={false}
              />
              <p className="text-xs text-gray-500 text-center">
                For macOS 14+ only
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

